import React from 'react';
import { useSelector } from 'react-redux';
import { IconButton } from '../../../../CommonComponents/OPL/IconButton/IconButton';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import {
  Menu,
  MenuContent,
  MenuItem,
  MenuSeparator,
  MenuTrigger,
} from '../../../../CommonComponents/OPL/Menu/Menu';
import { ListItem } from '../../../../CommonComponents/OPL/List/ListItem';
import { hasAccessToEditProfileSelector } from '../../../../CommonSelectors/CommonAreaSelector';

export interface Props {
  incomeName: string;
  onEdit(): void;
  onDelete(): void;
  onClone?(): void;
}

export const TableActions = ({ incomeName, onEdit, onDelete, onClone }: Props) => {
  const canEdit = useSelector(hasAccessToEditProfileSelector);

  return (
    <td>
      <Box width="100%" display="flex" justifyContent="flex-end">
        <Menu>
          <MenuTrigger>
            <IconButton
              aria-label={`${incomeName} menu`}
              icon="far fa-ellipsis-h"
              variant="subtleInactive"
              onClick={e => e.stopPropagation()}
            />
          </MenuTrigger>

          {canEdit && (
            <MenuContent align="end">
              <MenuItem onSelect={onEdit} onClick={e => e.stopPropagation()}>
                <ListItem icon="fas fa-pencil-alt">Edit</ListItem>
              </MenuItem>

              {onClone && (
                <MenuItem onSelect={onClone} onClick={e => e.stopPropagation()}>
                  <ListItem icon="far fa-clone">Clone</ListItem>
                </MenuItem>
              )}

              {onClone && <MenuSeparator />}

              <MenuItem onSelect={onDelete} onClick={e => e.stopPropagation()}>
                <ListItem icon="far fa-trash-alt" variant="error">
                  Delete
                </ListItem>
              </MenuItem>
            </MenuContent>
          )}

          {!canEdit && (
            <MenuContent align="end">
              <MenuItem onSelect={onEdit} onClick={e => e.stopPropagation()}>
                <ListItem icon="fas fa-eye">View</ListItem>
              </MenuItem>
            </MenuContent>
          )}
        </Menu>
      </Box>
    </td>
  );
};
